<template>
  <div>
    <v-view :tableData="tableData" :tableProps="tableProps" :modalProps="modalProps" :columns="columns" :routes="routes"
      :initialSort="initialSort" :buttonsVisibility="buttonsVisibility" :rowButtonAction="rowButtonAction"
      :unstyled="false" v-model:selectedRows="selectedRows">

      <template #crud="formProps">
        <StatusForm :formProps="formProps">
        </StatusForm>
      </template>
      <template #search="searchProps">
        <StatusSearch :searchProps="searchProps">
        </StatusSearch>
      </template>

    </v-view>
  </div>
</template>

<script setup>
import StatusForm from './StatusForm.vue'
import StatusSearch from './StatusSearch.vue'
import { ref } from "vue";
import { rowButtonAction } from '@pages/Helper/crud_utils.js'

const props = defineProps({
  tableData: Object,
  tableProps: Object,
  modalProps: Object,
  columns: Object,
  routes: Object,
  initialSort: Object,
  buttonsVisibility: Object,
})

const selectedRows = ref([])

//----------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
